import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

function Row({ children, className }) {
    const classes = cns('row', className);
    return (jsx("div", { className: classes, children: children }));
}
Row.defaultProps = {
    children: undefined,
    className: undefined,
};

export { Row as default };
